
import { Component, Vue, Watch } from 'vue-property-decorator';
import { lang } from '@/language';
import { Language as LanguageEnum } from '@/enums/Language';

@Component
export default class LanguagePicker extends Vue {
  public language: string = LanguageEnum.EN;

  get languages() {
    return [
      { value: LanguageEnum.DE, text: this.$t('languages.de'), icon: require('@/assets/svg/German.svg') },
      { value: LanguageEnum.EN, text: this.$t('languages.en'), icon: require('@/assets/svg/GB.svg') },
      { value: LanguageEnum.FR, text: this.$t('languages.fr'), icon: require('@/assets/svg/French.svg') },
      { value: LanguageEnum.NL, text: this.$t('languages.nl'), icon: require('@/assets/svg/Dutch.svg') },
      { value: LanguageEnum.IT, text: this.$t('languages.it'), icon: require('@/assets/svg/Italian.svg') },
    ];
  }

  public mounted(): void {
    const langPreference: string = localStorage.getItem('language')!;
    if (langPreference) {
      this.$i18n.locale = langPreference;
      this.language = langPreference;
    } else {
      this.$i18n.locale = lang;
    }
  }

  @Watch('language')
  public onLanguageChange(val: string) {
    this.$i18n.locale = val;
    localStorage.setItem('language', val);
  }
}
